<template>
  <div class="markdown-styles">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.markdown-styles {
  @include font-body-l-light;
  color: var(--color-neutral-70);
  margin: var(--spacing-16) 0;

  :deep(h1) {
    @include font-label-l-bold;
    color: var(--color-neutral-70);
    margin-top: var(--spacing-32);
    margin-bottom: var(--spacing-16);
  }

  :deep(p) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }
}
</style>
